require("../css/main.css");
require("../css/fontawesome-all.min.css");




// WEBPACK FOOTER //
// ./src/js/bootstrap.js